import { useState } from 'react';
import { supabase } from '../../../shared/services/supabase';
import { Customer } from '../../../shared/types';
import { validateCustomerData } from '../utils/customerValidation';

export const useCustomerCreate = () => {
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createCustomer = async (customerData: Partial<Customer>) => {
    setIsCreating(true);
    setError(null);

    try {
      // Validierung
      const validationResult = validateCustomerData(customerData);
      if (!validationResult.valid) {
        const firstError = Object.values(validationResult.errors)[0];
        throw new Error(firstError);
      }

      // Entferne undefined Werte und füge Defaults hinzu
      const cleanedData = Object.entries(customerData).reduce((acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = value;
        }
        return acc;
      }, {} as Record<string, any>);

      // Setze Default-Werte für optionale Felder
      const dataWithDefaults = {
        ...cleanedData,
        sv_pflicht: cleanedData.sv_pflicht ?? false,
        schaetzmandat: cleanedData.schaetzmandat ?? false,
        postalischer_versand: cleanedData.postalischer_versand ?? false,
        erster_lohnlauf_monat_offset: cleanedData.erster_lohnlauf_monat_offset ?? 0,
        zweiter_lohnlauf_monat_offset: cleanedData.zweiter_lohnlauf_monat_offset ?? 0,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString()
      };

      // Erstelle neuen Kunden in Supabase
      const { data, error: insertError } = await supabase
        .from('customers')
        .insert([dataWithDefaults])
        .select()
        .single();

      if (insertError) {
        throw insertError;
      }

      console.log('Neuer Kunde erfolgreich erstellt:', data.id);
      return data;
    } catch (err) {
      console.error('Error creating customer:', err);
      setError(err instanceof Error ? err.message : 'Unbekannter Fehler beim Erstellen');
      throw err;
    } finally {
      setIsCreating(false);
    }
  };

  return {
    createCustomer,
    isCreating,
    error
  };
};